// Inject 🌐 (language) + 🎨 (theme) buttons into v16's page-head AND sidebar.
// Both surfaces — the picker is the canonical entry but page-head is always
// visible regardless of the route.

import { theme } from "./prefs.js";
import { themePicker } from "./theme_picker.js";
import { t } from "../utils/i18n.js";
import { svg } from "../utils/icons.js";

const MARK = "e16-toolbar";

function lang() { return theme.currentLang(); }

function buttonLang() {
	const btn = document.createElement("button");
	btn.type = "button";
	btn.className = "e16-tbtn";
	btn.title = t("Switch language", lang());
	btn.setAttribute("aria-label", t("Switch language", lang()));
	btn.innerHTML = svg("globe", { size: 18 });
	btn.addEventListener("click", (ev) => {
		ev.preventDefault();
		const next = lang() === "ar" ? "en" : "ar";
		theme.applyLang(next, { persist: true, reload: true });
	});
	return btn;
}

function buttonTheme() {
	const btn = document.createElement("button");
	btn.type = "button";
	btn.className = "e16-tbtn";
	btn.title = t("Switch theme", lang());
	btn.setAttribute("aria-label", t("Switch theme", lang()));
	btn.innerHTML = svg("palette", { size: 18 });
	btn.addEventListener("click", (ev) => {
		ev.preventDefault();
		themePicker.open();
	});
	return btn;
}

function buildGroup(variant) {
	const wrap = document.createElement("div");
	wrap.className = `${MARK} ${MARK}--${variant}`;
	wrap.appendChild(buttonLang());
	wrap.appendChild(buttonTheme());
	return wrap;
}

function injectIntoPageHead() {
	const sa = document.querySelector(".page-head .standard-actions");
	if (!sa) return false;
	if (sa.querySelector(`.${MARK}--head`)) return true;
	sa.insertBefore(buildGroup("head"), sa.firstChild);
	return true;
}

function injectIntoSidebar() {
	const sidebar =
		document.querySelector(".body-sidebar") ||
		document.querySelector(".body-sidebar-container .body-sidebar");
	if (!sidebar) return false;
	if (sidebar.querySelector(`.${MARK}--sidebar`)) return true;
	const anchor =
		sidebar.querySelector(".body-sidebar-top") ||
		sidebar.querySelector(".sidebar-items") ||
		sidebar.querySelector(".standard-items-sections");
	const group = buildGroup("sidebar");
	if (anchor && anchor.parentNode) {
		anchor.parentNode.insertBefore(group, anchor);
	} else {
		sidebar.insertBefore(group, sidebar.firstChild);
	}
	return true;
}

function refreshLabels() {
	document.querySelectorAll(`.${MARK}`).forEach((n) => n.remove());
	tryAll();
}

function tryAll() {
	injectIntoPageHead();
	injectIntoSidebar();
}

function fixAppLogo() {
	try {
		var url = "/assets/erpnext16_theme/images/sidra-logo.png";
		if (window.frappe && frappe.boot && Array.isArray(frappe.boot.app_data)) {
			frappe.boot.app_data.forEach(function (a) { if (a) a.app_logo_url = url; });
		}
		// حدّث أي صورة شعار معروضة في الناف بار / رأس الشريط الجانبي
		document.querySelectorAll("#brand-logo, .navbar-home img, .app-logo, .navbar-brand img, .sidebar-standard-icon img, .standard-sidebar-item .sidebar-item-icon img").forEach(function (img) {
			if (img && img.tagName === "IMG") img.src = url;
		});
	} catch (e) {}
}

function rebrandText() {
	try {
		var map = [
			[/\bERPNext\b/g, "SIDRA SMART"],
			[/\bFrappe Framework\b/g, "SIDRA SMART"],
			[/\bFrappe\b/g, "SIDRA SMART"]
		];
		// عناصر العرض الآمنة فقط (عناوين، مسار، رأس مساحة العمل)
		var sel = ".page-title .title-text, .page-head .title-text, .navbar-brand, .breadcrumb .breadcrumb-item, .workspace-title, .ellipsis.title-text, h3.ellipsis, .app-logo-title, .sidebar-item-label";
		document.querySelectorAll(sel).forEach(function (el) {
			if (!el || el.children.length > 0) return; // نص خام فقط
			var txt = el.textContent;
			if (!txt) return;
			var out = txt;
			map.forEach(function (m) {
				if (out.indexOf("SIDRA SMART") === -1) {
					out = out.replace(m[0], m[1]);
				}
			});
			if (out !== txt) el.textContent = out;
		});
	} catch (e) {}
}

export const navbarInject = {
	mount() {
		tryAll();
		fixAppLogo();
		rebrandText();
		setTimeout(rebrandText, 600);
		setTimeout(rebrandText, 1600);
		setTimeout(fixAppLogo, 500);
		setTimeout(fixAppLogo, 1500);
		setTimeout(tryAll, 400);
		setTimeout(tryAll, 1200);

		document.addEventListener("e16:lang-applied", refreshLabels);

		try {
			if (window.frappe && frappe.router) {
				frappe.router.on("change", () => {
					setTimeout(tryAll, 250);
					setTimeout(tryAll, 900);
					setTimeout(rebrandText, 300);
					setTimeout(rebrandText, 1000);
					setTimeout(fixAppLogo, 400);
				});
			}
		} catch (e) {}
	},
};
